import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IDateForNotification {
  title: string | null;
  type: "success" | "error" | "warning" | null;
}

interface IInitialState {
  message: IDateForNotification;
}

const initialState: IInitialState = {
  message: {
    type: null,
    title: null,
  },
};

export const messagesSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    closeMessage(state) {
      state.message = initialState.message;
    },
    openSuccessMessage(state, action: PayloadAction<string>) {
      state.message = {
        title: action.payload,
        type: "success",
      };
    },
    openErrorMessage(state, action: PayloadAction<string>) {
      state.message = {
        title: action.payload,
        type: "error",
      };
    },
  },
});

export const { closeMessage, openSuccessMessage, openErrorMessage } = messagesSlice.actions;

export default messagesSlice.reducer;
